// removed by extract-text-webpack-plugin
module.exports = {"btnCancel":"btnCancel___3Z7FB","btnRemove":"btnRemove___2lDsa","btnSubmit":"btnSubmit___1rnQB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ButtonBar/styles.less
// module id = Lr1H
// module chunks = 18